import React from 'react';
import { useIntl } from 'react-intl';

const LookingUpSN = () => {
    const intl = useIntl();
    return (
        <>
            <div className="form-group">
                <div className="control-label col-sm-4 col-md-3"></div>
                <div
                    className="col-sm-8 col-md-6"
                    style={{ marginTop: '-10px' }}
                >
                    <img
                        style={{ marginRight: '3px' }}
                        src="/images/icons/loading.gif"
                        alt=""
                    />
                    <span>
                        {intl.formatMessage({
                            id: 'Looking_up_serial_number',
                            defaultMessage: 'Looking up serial number',
                        })}
                        ...
                    </span>
                </div>
            </div>
        </>
    );
};

export default LookingUpSN;
